var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signature_wrap"},[_vm._t("signature",function(){return [_c('input',{staticClass:"sign",attrs:{"type":"text","placeholder":"default","id":"sign"}}),_vm._m(0)]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"sign"}},[_c('button',[_vm._v("default")])])
}]

export { render, staticRenderFns }